import { ErrorActions } from "../../../../flux/Error";
import { FlagActions } from "../../../../flux/Flag";
import { SearchFn } from "../../../../../rest/Search";
import { EditCreatePersonStore } from "../EditCreatePersonStore";
import { EditCreatePersonActions } from "../EditCreatePersonActions";
import { Command } from "../../../../../Command";

export class InitUpsertPersonCommand implements Command
{
    private editActions = new EditCreatePersonActions();
    private errorActions = new ErrorActions();
    private inProgressActions = new FlagActions();
    
    constructor(private runSearch: SearchFn, private store: EditCreatePersonStore, private getDidivionId: () => number, private inProgressDispatchToken: string, private errorDispatchToken: string)
    {        
    }
    
    execute = () => {
        this.errorActions.clearError(this.errorDispatchToken); // reset error from previous edit session
        this.inProgressActions.set(this.inProgressDispatchToken);
        this.runSearch({ Name: 'Divisions' })
            .then(res => {
                const { Division: divisions } = res.Entries
                const { DivisionRegId, id } = this.store.getState().draft;
                if(DivisionRegId == null && id == null) {
                    const currDivisionId = this.getDidivionId();
                    const division = divisions.find(d => d.id === currDivisionId);
                    if(division) {
                        this.editActions.setDivision(division.id);
                    }
                }
                this.editActions.setDivisionItems(divisions);
            })
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken))
            .then(() => this.inProgressActions.reset(this.inProgressDispatchToken)); // finaly
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Person/commands/InitUpsertPersonCommand.ts